import type { PlatformRole } from '../api/m19';

/**
 * Mirrors PLATFORM_CAPABILITIES in the backend (`src/modules/platform/platform-auth.ts`) plus M19's
 * `admins.manage`. Cosmetic only: the API enforces every capability.
 */
export const PLATFORM_CAPABILITIES = {
  'tenants.view': ['SUPER_ADMIN', 'BILLING', 'SUPPORT'],
  'tenants.create': ['SUPER_ADMIN', 'BILLING'],
  'tenants.suspend': ['SUPER_ADMIN'],
  'tenants.menus': ['SUPER_ADMIN', 'BILLING'],
  'tenants.backup': ['SUPER_ADMIN', 'BILLING'],
  'tenants.users.manage': ['SUPER_ADMIN'],
  'subscriptions.manage': ['SUPER_ADMIN', 'BILLING'],
  'codes.manage': ['SUPER_ADMIN', 'BILLING'],
  'plans.manage': ['SUPER_ADMIN'],
  'audit.view': ['SUPER_ADMIN', 'SUPPORT'],
  'admins.manage': ['SUPER_ADMIN'],
  'settings.manage': ['SUPER_ADMIN'],
  'support.chat': ['SUPER_ADMIN', 'SUPPORT', 'BILLING'],
} as const satisfies Record<string, readonly PlatformRole[]>;

export type Capability = keyof typeof PLATFORM_CAPABILITIES;

export function roleCan(role: PlatformRole | null | undefined, capability: Capability): boolean {
  if (!role) return false;
  return (PLATFORM_CAPABILITIES[capability] as readonly PlatformRole[]).includes(role);
}

export const ROLE_LABELS: Record<PlatformRole, string> = {
  SUPER_ADMIN: 'Super admin',
  BILLING: 'Billing',
  SUPPORT: 'Support',
};
